export default {
      id: "phone-book-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons.HITByrwA.svg#phone-book-usage",
      toString: function () {
        return this.url;
      }
    }